import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/horoscope/today-horoscope/[sign]/page.tsx");
